import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { createTheme } from '@mui/material/styles';
import { PROMETHEAN_BLUE, PROMETHEAN_NEUTRAL_PLUM, PROMETHEAN_NEUTRAL_WHITE, PROMETHEAN_PURPLE_GRAPE, PROMETHEAN_TEXT } from '../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_SUBTITLE_04 } from '../styles/typography/typography';
export var ROOT_PREFIX = 'EmbersMenuItem';
export var DELETE_BTN_FOCUS_VISIBLE_CLASS = 'EmbersMenuItemDeleteButton-focusVisible';
export var DELETE_BTN_HAS_FOCUS_VISIBLE_CLASS = 'EmbersMenuItem-deleteButtonHasFocusVisible';
export var createMenuItemsTheme = function createMenuItemsTheme() {
  var _hover, _$concat2, _MuiFocusVisibleN, _$concat3, _objectSpread2, _$concat4, _root;
  return createTheme({
    components: {
      MuiTypography: {
        styleOverrides: {
          root: _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_04), {}, {
            whiteSpace: 'normal',
            minHeight: 24,
            width: '100%',
            paddingTop: 6,
            paddingRight: 4,
            paddingBottom: 6,
            paddingLeft: 0,
            wordBreak: 'break-word'
          })
        }
      },
      MuiMenuItem: {
        styleOverrides: {
          root: _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_04), {}, (_objectSpread2 = {
            padding: '0 24px 0px 16px',
            alignItems: 'flex-start',
            /** fix ios 13.6 bug that menu will miss height */
            minHeight: 'fit-content!important',
            transition: 'background 0.2s linear',
            '&:before': {
              content: '""',
              position: 'absolute',
              left: 0,
              top: 0,
              width: 0,
              height: '100%',
              background: PROMETHEAN_PURPLE_GRAPE,
              transition: '0.1s linear width'
            }
          }, _defineProperty(_objectSpread2, "&:not(.".concat(ROOT_PREFIX, "-clickable)"), {
            cursor: 'default',
            '&:hover': {
              backgroundColor: PROMETHEAN_NEUTRAL_WHITE
            }
          }), _defineProperty(_objectSpread2, "&.".concat(ROOT_PREFIX, "-clickable"), (_$concat3 = {}, _defineProperty(_$concat3, "&.".concat(ROOT_PREFIX, "-checkable"), {
            padding: '0px 24px 0px 8px'
          }), _defineProperty(_$concat3, "&.".concat(ROOT_PREFIX, "-hasPrefix"), _defineProperty({}, ".".concat(ROOT_PREFIX, "-prefix"), {
            minWidth: 'auto',
            '[class*="icon-"]': {
              fontSize: 16
            }
          })), _defineProperty(_$concat3, "&.".concat(ROOT_PREFIX, "-hasSuffix"), {
            paddingRight: 16,
            justifyContent: 'space-between'
          }), _defineProperty(_$concat3, "&.".concat(ROOT_PREFIX, "-deletable"), {
            paddingRight: 40
          }), _defineProperty(_$concat3, ".".concat(ROOT_PREFIX, "-unchecked-icon"), {
            fill: PROMETHEAN_TEXT
          }), _defineProperty(_$concat3, "&:not(.".concat(ROOT_PREFIX, "-touchDevice)"), {
            '&:hover': {
              background: PROMETHEAN_NEUTRAL_PLUM
            }
          }), _defineProperty(_$concat3, '&:hover', (_hover = {}, _defineProperty(_hover, ".".concat(ROOT_PREFIX, "-delete-icon"), {
            visibility: 'visible'
          }), _defineProperty(_hover, ".".concat(ROOT_PREFIX, "-unchecked-icon"), {
            fill: PROMETHEAN_PURPLE_GRAPE
          }), _hover)), _defineProperty(_$concat3, '&:active, &.Mui-selected', {
            position: 'relative',
            background: PROMETHEAN_NEUTRAL_PLUM,
            '&:before': {
              width: 4
            },
            '&:hover': {
              background: PROMETHEAN_NEUTRAL_PLUM
            },
            '&.Mui-focusVisible:not(&.EmbersInputSelectItem-root), &.EmbersMenuItem-isActiveDescendent': {
              background: PROMETHEAN_NEUTRAL_PLUM
            }
          }), _defineProperty(_$concat3, '&.Mui-focusVisible:not(&.EmbersInputSelectItem-root), &.EmbersMenuItem-isActiveDescendent', (_MuiFocusVisibleN = {
            background: PROMETHEAN_NEUTRAL_PLUM
          }, _defineProperty(_MuiFocusVisibleN, "&.".concat(ROOT_PREFIX, "-deletable"), (_$concat2 = {
            outline: 'none'
          }, _defineProperty(_$concat2, ":not(&.".concat(DELETE_BTN_HAS_FOCUS_VISIBLE_CLASS, ")"), {
            position: 'relative',
            ':after': {
              content: '" "',
              position: 'absolute',
              display: 'block',
              top: 0,
              right: 36,
              bottom: 0,
              left: 0,
              outline: '2px solid ' + PROMETHEAN_BLUE,
              outlineOffset: -2
            }
          }), _defineProperty(_$concat2, ".".concat(ROOT_PREFIX, "-delete-icon"), {
            visibility: 'visible'
          }), _$concat2)), _defineProperty(_MuiFocusVisibleN, ":not(&.".concat(ROOT_PREFIX, "-deletable)"), _defineProperty({
            outline: '2px solid ' + PROMETHEAN_BLUE,
            outlineOffset: -2
          }, ".".concat(ROOT_PREFIX, "-unchecked-icon"), {
            fill: PROMETHEAN_PURPLE_GRAPE
          })), _MuiFocusVisibleN)), _$concat3)), _defineProperty(_objectSpread2, '.EmbersMenuItem-checkbox', {
            margin: 0,
            '.MuiCheckbox-root': {
              border: 'none !important',
              backgroundColor: 'transparent !important',
              height: 36,
              width: 40,
              maxHeight: 36,
              maxWidth: 40,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              padding: 0
            },
            '.MuiTypography-root': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_04), {}, {
              whiteSpace: 'normal',
              minHeight: 24,
              width: '100%',
              paddingTop: 6,
              paddingRight: 4,
              paddingBottom: 6,
              paddingLeft: 0,
              wordBreak: 'break-word',
              margin: 0,
              textAlign: 'left'
            })
          }), _objectSpread2))
        }
      },
      MuiListItemIcon: {
        styleOverrides: {
          root: (_root = {
            '&>*': {
              fontSize: '16px'
            },
            color: PROMETHEAN_TEXT
          }, _defineProperty(_root, "&.".concat(ROOT_PREFIX, "-prefix"), {
            minWidth: 'auto',
            marginRight: 4,
            height: 24,
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: 6
          }), _defineProperty(_root, "&.".concat(ROOT_PREFIX, "-suffix"), {
            minWidth: 'auto',
            height: 36,
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: 18
          }), _defineProperty(_root, "&.".concat(ROOT_PREFIX, "-delete-icon"), (_$concat4 = {
            position: 'absolute',
            display: 'block',
            right: 0,
            marginLeft: 0,
            height: 36,
            paddingTop: 6,
            paddingLeft: 6,
            paddingBottom: 0,
            paddingRight: 0,
            visibility: 'hidden',
            transition: 'background 0.2s linear',
            color: PROMETHEAN_TEXT,
            outline: 'none'
          }, _defineProperty(_$concat4, "&.".concat(DELETE_BTN_FOCUS_VISIBLE_CLASS), {
            background: PROMETHEAN_PURPLE_GRAPE,
            color: PROMETHEAN_NEUTRAL_WHITE,
            outline: '2px solid ' + PROMETHEAN_BLUE,
            outlineOffset: -2,
            border: '3px solid ' + PROMETHEAN_NEUTRAL_WHITE,
            paddingLeft: 3,
            paddingTop: 3
          }), _defineProperty(_$concat4, '&:hover', {
            visibility: 'visible',
            background: PROMETHEAN_PURPLE_GRAPE,
            color: PROMETHEAN_NEUTRAL_WHITE
          }), _defineProperty(_$concat4, "&.".concat(ROOT_PREFIX, "-suffix"), {
            minWidth: 36,
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
            top: 0,
            right: 0
          }), _defineProperty(_$concat4, '&> i', {
            fontSize: '24px',
            marginTop: 6
          }), _$concat4)), _root)
        }
      },
      MuiTouchRipple: {
        styleOverrides: {
          root: {
            color: PROMETHEAN_NEUTRAL_PLUM,
            opacity: 1
          }
        }
      }
    }
  });
};